import { render, staticRenderFns } from "./CircuitsTab.vue?vue&type=template&id=0cf7cae7&scoped=true"
import script from "./CircuitsTab.vue?vue&type=script&lang=js"
export * from "./CircuitsTab.vue?vue&type=script&lang=js"
import style0 from "./CircuitsTab.vue?vue&type=style&index=0&id=0cf7cae7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf7cae7",
  null
  
)

export default component.exports